import { render } from "./Language.vue?vue&type=template&id=da2174e8&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=da2174e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\schmidch\\IdeaProjects\\soilmap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2174e8"]])

export default __exports__